import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { verifyIc } from '../redux/verify/actions';
import * as verifyStatus from '../redux/verify/status';
import { flashMessage } from '../redux/flash/actions';

import { getS3Object } from '../utils/myKadImg';
import { authenticateCurrentUser } from '../redux/authenticate/actions';

import Date from '../components/Date';
import ListCollapse from '../components/ListCollapse';
import Image from '../components/Image';
import Modal from '../components/Modal';
import Value from '../components/Value';
import Identity from '../components/Identity';

import cross from '../assets/icons/ic-close.svg';
import tick from '../assets/icons/ic-tick.svg';

import './ListItems.css';

const VERIFICATIONS_STATUS = ["Approve", "Reject", "Retry"];

class IcVerifyListItems extends Component {
  static propTypes = {
    profileVerifications: PropTypes.array,
    reveal: PropTypes.string,
  }

  static defaultProps = {
    profileVerifications: [],
    reveal: '',
  }

  static contextTypes = {
    store: PropTypes.object,
  }

  constructor(props) {
    super(props);
    this.state = {
      images: [],
      reveal: props.reveal,
      verificationStatus: VERIFICATIONS_STATUS,
      showModal: false,
    };
  }

  async componentDidMount() {
    await this.loadImages();
  }

  componentWillUnmount() {
    this.loadImages();
  }

  async componentWillReceiveProps(nextProps) {
    if (this.props.profileVerifications ||
      this.props.profileVerifications.icFront !== nextProps.profileVerifications.icFront ||
      this.props.profileVerifications.icBack !== nextProps.profileVerifications.icBack
    ) {
      this.loadImages();
    }
    if (nextProps.reveal !== this.props.reveal) {
      this.setState({ reveal: nextProps.reveal });
    }
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  async loadImages() {
    await this.setStateAsync({ loadingImages: true });
    const { store } = this.context;
    const { profileVerifications } = this.props;
    const token = await store.dispatch(authenticateCurrentUser());
    let images;
    try {
      const runImages = [];
      profileVerifications.forEach((obj, idx) => {
        if (obj.icFront) {
          runImages.push(getS3Object(obj.icFront, 'icFront', token));
        }
        if (obj.icBack) {
          runImages.push(getS3Object(obj.icBack, 'icBack', token));
        }
      });
      images = await Promise.all(runImages);
    } catch (e) {
      return;
    }
    await this.setStateAsync({
      images,
      loadingImages: false,
    });
  }

  getIcVerify = (ic) => {
    switch (ic) {
      case true:
        return 'True'
      default:
        return 'False';
    }
  }

  renderMatch = (obj) => {
    if (
      obj.name === obj.ocrName &&
      obj.nric === obj.ocrNric
    ) {
      return (
        <img src={tick} alt="Match" />
      );
    }
    return (
      <img src={cross} alt="Not match" />
    );
  }

  handleSelect = async (value) => {
    this.setState({value})
  }

  handleOpenModal = (obj) => {
    this.setState({
      showModal: this.state.showModal === obj ? null : obj,
    });
  }

  handleCloseModal = (event) => {
    event.preventDefault();
    this.setState({ showModal: false });
  }

  getReveal = () => {
    this.props.onReveal(this.state.reveal);
  }

  toggleShow = (i) => {
    this.setState({
      reveal: this.state.reveal === i ? null : i
    }, () => {
      this.getReveal();
    });
  }

  approve = async (obj) => {
    this.setState({ showModal: false });
    const { store } = this.context;
    const body = {
      userID: obj.userID,
      profileID: obj.profileID,
    };
    const res = await store.dispatch(verifyIc(body));
    if (res === verifyStatus.VERIFYIC_STATUS_OK) {
      store.dispatch(flashMessage(`${obj.nric} Approved`, 'notify'));
      return;
    }
    store.dispatch(flashMessage(`Fail to approve ${obj.nric}`, 'error'));
  }

  render() {
    return (
      <div className="ListItems">
        {
          [].concat(this.props.profileVerifications).map((obj, i) => {
            const uploadedICFront = this.state.images.find(i => i.key === obj.icFront && i.name === 'icFront');
            const uploadedICBack = this.state.images.find(i => i.key === obj.icBack && i.name === 'icBack');
            return (
              <Row key={i}>
                <Modal
                  close={this.state.showModal === obj.profileID}
                  onClickNo={this.handleCloseModal}
                  onClickYes={() => this.approve(obj)}
                >
                  Are you sure you want to verify <br /> {obj.name} IC?
                </Modal>
                <Row className="row-eq-height">
                  <Col className="indexCol">{i+1}</Col>
                  <Col className="createdAt"><Date>{obj.createdAt}</Date></Col>
                  <Col xs={5}>
                    <b>Name</b>: {obj.name}&nbsp;&nbsp;&nbsp;
                    <b>NRIC</b>: <Identity type={1} identity={`${obj.nric}`} /> 
                    <br /><br />
                    {
                      this.props.profileVerifications && uploadedICFront ?
                       <Image inline src={uploadedICFront ? uploadedICFront.body : null} alt="icFront" loading={this.state.loadingImages}/>
                       : <div>No Front IC</div>
                     }
                     {
                       this.props.profileVerifications && uploadedICBack ?
                       <Image inline src={uploadedICBack ? uploadedICBack.body : null} alt="icBack" loading={this.state.loadingImages}/>
                       : <div>No Back IC</div>
                     }
                  </Col>
                  <Col xs={3}>
                    <b>MyKad Name</b>: {obj.ocrName} <br />
                    <b>MyKad NRIC</b>: <Identity type={1} identity={`${obj.ocrNric}`} /> <br />
                    <br />
                    <b>Verify status</b>: <code>{obj.ocrStatus}</code> <br />
                    <b>Verify Retry Count</b>: <Value>{obj.ocrRetry}</Value> <br />
                    <b>User reported issue:</b> {obj.hasOCRIssue ? 'Yes' : 'No'} <br />
                  </Col>
                  <Col xs={1}>
                    <div className="matchImg">{this.renderMatch(obj)}</div>
                  </Col>
                  <Col className="actionCol">
                    <button className="buttonLink" onClick={() => this.toggleShow(obj.profileID)}>
                      {this.state.reveal === obj.profileID ? 'Hide Details' : `View Details`}
                    </button>
                    <button className="buttonLink" onClick={() => this.handleOpenModal(obj.profileID)}>
                      Manually Verify
                    </button>
                    <a className="buttonLink" href={`mailto:${obj.email}?Subject=[DSR-PG]`} target="_top">
                      Contact User
                    </a>
                  </Col>
                </Row>
                <ListCollapse reveal={this.state.reveal === obj.profileID}>
                  <Row>
                    <Col xs={2}>
                      <b>Last Updated</b>: <br /> <Date time>{obj.lastUpdated}</Date>
                    </Col>
                    <Col xs={4}>
                      <b>Email</b>: {obj.email} <br/>
                      <b>Mobile</b>: {obj.mobile} <br/>
                    </Col>
                    <Col xs={4}>
                      <b>OCR Count</b>: <Value>{obj.ocrCount}</Value> <br />
                      <b>Ocr ID</b>: {obj.ocrID} <br />
                      <b>User ID</b>: {obj.userID} <br/>
                      <b>Profile ID</b>: {obj.profileID} <br/>
                    </Col>
                  </Row>
                </ ListCollapse>
              </Row>
            )
          })
        }
      </div>
    );
  }
}

export default connect(IcVerifyListItems.mapStateToProps)(IcVerifyListItems);



// WEBPACK FOOTER //
// ./src/components/IcVerifyListItems.jsx